export default __webpack_public_path__ + "static/equilibre_icon_business-dc730cfd239234324d730c3f9dbe4577.png";